import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
.EpisodeInfo {
  padding: 24px;
}

.name {
  color: ${colors.primaryText};
  font-size: 24px;
  width: 100%;
  display: inline-block;
  line-height: 1.2;
  margin-bottom: .5em;
  padding-bottom: 3px;
  text-transform: uppercase;
}

.title {
  color: ${colors.textHoverPurple};
  display: inline-block;
  font-weight: bold;
  margin-right: 16px;
  max-width: 65%;
}

.duration {
  color: ${colors.primaryText}
}

.summary,
.expiry-date {
  font-size: 14px;
  color: ${colors.secondaryText};
}

.summary {
  margin: 16px 0;
}

p.summary {
  color: ${colors.primaryText}
}

.available-until {
  font-size: 14px;
  font-weight: bold;
  color: ${colors.primaryText};
}

.available-until-row{
  margin-bottom: 5px;
}

.extra-info {
  margin: 12px 0;
}

.more-episodes {
  margin-top: 42px;
  font-size: 14px;
}

@media (min-width: 1024px) {
  .EpisodeInfo {
    padding: 36px;
  }
}
`
